import React, { Component } from 'react';
import { FieldArray } from 'redux-form';
import FeedModifier from './FeedModifier';

class FeedModifiers extends Component {
  render() {
    return (
      <div>
        <FieldArray name={'modifiers'} component={FeedModifier} />
      </div>           
    );
  }
}

export default (FeedModifiers);
